import { render, staticRenderFns } from "./GoodOrder.vue?vue&type=template&id=06098ee7&"
import script from "./GoodOrder.vue?vue&type=script&lang=js&"
export * from "./GoodOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports